import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @Input() variant: 'default' | 'interactive' | 'job' = 'default';
  @Input() background: 'white' | 'blue' = 'white';
  @Input() orientation: 'vertical' | 'horizontal' = 'horizontal';
  @Input() interactive = false;
  @Input() ai = false;
  @Input() hasHeader = false;
  @Input() hasFooter = false;
  @Input() hasDetails = false;
}
